import { SidebarEffects } from './sidebar.effects';
import { CountriesEffects } from './countries.effects';
import { RolesEffects } from './roles.effects';
export * from './sidebar.effects';

/**
 * a medida que se van agregando efectos este array debe actualizarce
 */
export const effects: any[] = [
  SidebarEffects,
  CountriesEffects
];
